/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: <Template required by Ant: https://github.com/ant-design/ant-design/blob/master/components/locale/en_US.ts> */
import { Locale } from 'antd/lib/locale'
import Pagination from './rc-pagination'
import PickerLocale from './rc-picker'

const DatePicker = {
  lang: {
    ...PickerLocale,
    placeholder: 'తేదీని ఎంచుకోండి',
    yearPlaceholder: 'సంవత్సరం',
    quarterPlaceholder: 'క్వార్టర్',
    monthPlaceholder: 'నెల',
    weekPlaceholder: 'వారం',
    rangePlaceholder: ['ప్రారంభ తేదీ', 'ముగింపు తేదీ'] as [string, string],
    rangeYearPlaceholder: ['ప్రారంభ సంవత్సరం', 'ముగింపు సంవత్సరం'] as [string, string],
    rangeMonthPlaceholder: ['ప్రారంభ నెల', 'ముగింపు నెల'] as [string, string],
    rangeWeekPlaceholder: ['ప్రారంభ వారం', 'ముగింపు వారం'] as [string, string],
  },
  timePickerLocale: {
    placeholder: 'సమయం ఎంచుకోండి',
  },
}

const TimePicker = {
  placeholder: 'సమయం ఎంచుకోండి',
  rangePlaceholder: ['ప్రారంభ సమయం', 'ముగింపు సమయం'],
}

const Calendar = DatePicker.lang

const typeTemplate = '${label} చెల్లుబాటు అయ్యే ${type} కాదు'

export const antTeIn: Locale = {
  locale: 'te',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  global: {
    placeholder: 'దయచేసి ఎంచుకోండి',
    close: 'మూసివేయి',
  },

  Table: {
    filterTitle: 'ఫిల్టర్ మెను',
    filterConfirm: 'సరే',
    filterReset: 'రీసెట్',
    filterEmptyText: 'ఫిల్టర్లు లేవు',
    filterCheckAll: 'అన్ని అంశాలను ఎంచుకోండి',
    filterSearchPlaceholder: 'ఫిల్టర్‌లలో వెతకండి',
    emptyText: 'డేటా లేదు',
    selectAll: 'ప్రస్తుత పేజీని ఎంచుకోండి',
    selectInvert: 'ప్రస్తుత పేజీని తారుమారు చేయి',
    selectNone: 'అన్నీ క్లియర్ చేయి',
    selectionAll: 'అన్ని డేటాను ఎంచుకోండి',
    sortTitle: 'క్రమబద్ధీకరణ',
    expand: 'వరుసను విస్తరించు',
    collapse: 'వరుసను కుదించు',
    triggerDesc: 'దిగి క్రమబద్ధీకరించడానికి క్లిక్ చేయి',
    triggerAsc: 'ఎగబాకి క్రమబద్ధీకరించడానికి క్లిక్ చేయి',
    cancelSort: 'క్రమబద్ధీకరణ రద్దు చేయి',
  },

  Tour: {
    Next: 'తదుపరి',
    Previous: 'మునుపటి',
    Finish: 'ముగించు',
  },

  Modal: {
    okText: 'సరే',
    cancelText: 'రద్దు',
    justOkText: 'సరే',
  },

  Popconfirm: {
    okText: 'సరే',
    cancelText: 'రద్దు',
  },

  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ఇక్కడ వెతకండి',
    itemUnit: 'అంశం',
    itemsUnit: 'అంశాలు',
    remove: 'తొలగించు',
    selectCurrent: 'ప్రస్తుత పేజీని ఎంచుకోండి',
    removeCurrent: 'ప్రస్తుత పేజీని తీసివేయి',
    selectAll: 'అన్ని డేటాను ఎంచుకోండి',
    deselectAll: 'అన్నింటిని డీసెలెక్ట్ చేయి',
    removeAll: 'అన్ని డేటాను తొలగించు',
    selectInvert: 'ప్రస్తుత పేజీని తారుమారు చేయి',
  },

  Upload: {
    uploading: 'అప్‌లోడ్ అవుతోంది...',
    removeFile: 'ఫైల్ తొలగించు',
    uploadError: 'అప్‌లోడ్ లోపం',
    previewFile: 'ఫైల్‌ను ప్రివ్యూ చేయండి',
    downloadFile: 'ఫైల్ డౌన్‌లోడ్',
  },

  Empty: {
    description: 'డేటా లేదు',
  },

  Icon: {
    icon: 'ఐకాన్',
  },

  Text: {
    edit: 'సవరించు',
    copy: 'కాపీ',
    copied: 'కాపీ అయింది',
    expand: 'విస్తరించు',
    collapse: 'కుదించు',
  },

  Form: {
    optional: ' (ఐచ్చికం)',
    defaultValidateMessages: {
      default: 'ఫీల్డ్ ధృవీకరణ లోపం: ${label}',
      required: 'దయచేసి ${label} నమోదు చేయండి',
      enum: '${label} తప్పనిసరిగా [${enum}] లో ఒకటి కావాలి',
      whitespace: '${label} ఖాళీ అక్షరం కాలేదు',
      date: {
        format: '${label} తేదీ ఫార్మాట్ చెల్లదు',
        parse: '${label} ను తేదీగా మార్పు చేయలేము',
        invalid: '${label} చెల్లని తేదీ',
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate,
      },
      string: {
        len: '${label} ఖచ్చితంగా ${len} అక్షరాలు ఉండాలి',
        min: '${label} కనీసం ${min} అక్షరాలు ఉండాలి',
        max: '${label} గరిష్టంగా ${max} అక్షరాలు మాత్రమే',
        range: '${label} ${min}-${max} అక్షరాల మధ్య ఉండాలి',
      },
      number: {
        len: '${label} ${len} కి సమానం కావాలి',
        min: '${label} కనీసం ${min} కావాలి',
        max: '${label} గరిష్టంగా ${max} కావాలి',
        range: '${label} ${min}-${max} మధ్య ఉండాలి',
      },
      array: {
        len: '${label} ${len} ఉండాలి',
        min: 'కనీసం ${min} ${label}',
        max: 'గరిష్టంగా ${max} ${label}',
        range: '${label} పరిమాణం ${min}-${max} మధ్య ఉండాలి',
      },
      pattern: {
        mismatch: '${label} మాదిరి ${pattern} కి సరిపోలడం లేదు',
      },
    },
  },

  Image: {
    preview: 'ప్రివ్యూలు',
  },

  QRCode: {
    expired: 'QR కోడ్ గడువు ముగిసింది',
    refresh: 'రిఫ్రెష్',
    scanned: 'స్కాన్ అయింది',
  },

  ColorPicker: {
    presetEmpty: 'ఖాళీ',
    transparent: 'పారదర్శకం',
    singleColor: 'ఒకటి',
    gradientColor: 'గ్రాడియెంట్',
  },
}
